import { exists } from '../runtime';
import { Lead, LeadFromJSON, LeadToJSON } from './Lead';

export interface InlineResponse20014 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  previous?: string | null;
  /**
   *
   * @type {Array<Lead>}
   * @memberof InlineResponse20014
   */
  results: Array<Lead>;
}

export function InlineResponse20014FromJSON(json: any): InlineResponse20014 {
  return InlineResponse20014FromJSONTyped(json);
}

export function InlineResponse20014FromJSONTyped(json: any): InlineResponse20014 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    count: json['count'],
    next: !exists(json, 'next') ? undefined : json['next'],
    previous: !exists(json, 'previous') ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(LeadFromJSON),
  };
}

export function InlineResponse20014ToJSON(value?: InlineResponse20014 | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    count: value.count,
    next: value.next,
    previous: value.previous,
    results: (value.results as Array<any>).map(LeadToJSON),
  };
}
